export default __webpack_public_path__ + "static/media/double-quotation-mark.5ad978d5.svg";